/* eslint-disable jira/naming/disallow-filenames */
/** @jsx jsx */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';

export type EmojiWrapperProps = {
	children: React.ReactNode;
	standalone?: boolean;
	color?: string;
	className?: string;
	withTagDecoration?: boolean;
};

export const EmojiWrapper = ({
	standalone,
	color,
	children,
	className,
	withTagDecoration,
}: EmojiWrapperProps): JSX.Element => {
	return (
		<div
			css={[
				wrapperStyles,
				standalone && borderRadiusStandalone,
				!standalone && borderRadiusNonStandalone,
				withTagDecoration &&
					fg('platform-dst-lozenge-tag-badge-visual-uplifts') &&
					tagDecorationStyles,
			]}
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{
				backgroundColor: color,
			}}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
			className={className}
		>
			{children}
		</div>
	);
};

const wrapperStyles = css({
	overflow: 'hidden',
	gridArea: 'icon',
	width: '24px',
	height: '22px',
	boxSizing: 'border-box',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const borderRadiusStandalone = css({
	borderRadius: token('radius.small', '3px'),
});

const borderRadiusNonStandalone = css({
	borderRadius: `${token('radius.small', '3px')} 0 0 ${token('radius.small', '3px')}`,
});

const tagDecorationStyles = css({
	width: '20px',
	height: '20px',
	borderTopWidth: token('border.width'),
	borderTopStyle: 'solid',
	borderTopColor: token('color.border'),
	borderInlineStartWidth: token('border.width'),
	borderInlineStartStyle: 'solid',
	borderInlineStartColor: token('color.border'),
	borderBottomWidth: token('border.width'),
	borderBottomStyle: 'solid',
	borderBottomColor: token('color.border'),
	borderInlineEndWidth: '0',
});
